"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTime = void 0;
const date_fns_1 = require("date-fns");
const types_shared_1 = require("../types.shared");
const time_1 = require("../helpers/time");
const validateTime = ({ userState, filteredLocations, useDeliveryTimes, deliveryTimeRange, }) => {
    if (!userState.time) {
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_TIME' }),
            newLocations: filteredLocations,
        };
    }
    if (!userState.date) {
        return {
            result: (0, types_shared_1.error)({ code: 'NO_DATE' }),
            newLocations: filteredLocations,
        };
    }
    const minDate = (0, time_1.getMinDateAllowed)(filteredLocations, userState, useDeliveryTimes);
    const time = `${minDate.getHours()}${minDate.getMinutes().toString().padStart(2, '0')}`;
    const chosenTime = minDate && minDate >= new Date(userState.date) ? Number(time) : undefined;
    const timeSlots = (0, time_1.timePopoverFormat)({
        ...(0, time_1.calculateOptions)(filteredLocations, userState.date, useDeliveryTimes, deliveryTimeRange),
        chosenTime,
    });
    if (!timeSlots.includes(userState.time || '')) {
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_TIME' }),
            newLocations: filteredLocations,
        };
    }
    if ((0, date_fns_1.isSameDay)(userState.date, new Date()) &&
        Number(userState.time.split(' - ')[0].replace(':', '')) < Number((0, date_fns_1.format)(new Date(), 'HHmm'))) {
        return {
            result: (0, types_shared_1.error)({ code: 'TIME_PAST' }),
            newLocations: filteredLocations,
        };
    }
    const [chosenStart, chosenEnd] = userState.time.split(' - ');
    const newSelectedVendorLocations = filteredLocations.filter((loc) => {
        const startTime = (0, time_1.getEarliestTime)(loc.openingTimes);
        const endTime = (0, time_1.getLatestTime)(loc.openingTimes);
        return (Number(chosenStart.replace(':', '')) >= startTime &&
            Number(chosenEnd.replace(':', '')) <= endTime);
    });
    return {
        result: (0, types_shared_1.ok)(),
        newLocations: newSelectedVendorLocations,
    };
};
exports.validateTime = validateTime;
